module.exports = __webpack_public_path__ + "static/img/5318_phase_function_Paper_PointsHejduk_Prediction.21ec1de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5318_phase_function_Paper_PointsHejduk_Prediction.png
// module id = yZFT
// module chunks = 0